// src/project/data/triggers/launchWithdrawal.js
import { getUserId, getRiderId } from '../config/apiConfig'
import { calculateFee, getProviderToUse } from '../services/withdrawal/withdrawalHelpers'

export default {
  postUrl() {
    // Nouveau endpoint V3 : withdrawal via queue broadcast (identique à l'app client)
    return 'https://api.monrapidoo.com/queue/broadcast/data/rapidoo-transactions/withdrawalRequested?group=commons'
  },
  async format(payload) {
    const fees = await calculateFee(payload.amount)

    if (!fees) {
      throw new Error(
        'Impossible de calculer les frais de retrait. Veuillez réessayer ultérieurement.',
      )
    }

    const provider = await getProviderToUse(false)

    if (!provider) {
      throw new Error(
        'Impossible de récupérer le fournisseur de paiement. Veuillez réessayer ultérieurement.',
      )
    }

    const userId = getUserId()
    const riderId = getRiderId()

    let phone = String(payload.phoneNumber || '').replace(/\+/g, '').replace(/\s+/g, '').trim()
    if (phone.startsWith('229') && phone.length > 8) {
      // already has 229 prefix
    } else {
      phone = `229${phone}`
    }

    return {
      id: `trx_wallet_debit_${Date.now()}`,
      requestId: `req_wallet_debit_${Date.now()}`,
      type: 'walletDebit',
      src: {
        wallet: `wallet_${riderId}`,
        service: 'rapidoo',
        processor: 'rapidoWallet',
        currency: 'XOF',
        amount: fees.srcAmount,
        country: 'any',
      },
      dst: {
        service: 'rapidoo',
        currency: 'XOF',
        amount: fees.dstAmount,
        country: 'BJ',
        firstName: payload.firstName || '',
        lastName: payload.lastName || '',
        phoneNumber: phone,
      },
      metadata: {
        provider: provider,
        source: 'rider',
        ownerId: userId,
        riderId,
        wallet: `wallet_${riderId}`,
        narration: 'withdraw Wallet',
        fees: {
          srcAmount: fees.srcAmount,
          dstAmount: fees.dstAmount,
          totalFeeCalculated: fees.totalFeeCalculated,
          feePercent: fees.feePercent,
          feeFix: fees.feeFix,
          feePercentCalculated: fees.feePercentCalculated,
          applyFeeOnSrc: fees.applyFeeOnSrc,
        },
      },
    }
  },
  parse(raw = {}) {
    // Réponse V3 (queue broadcast) :
    // { statusCode: 200, message: "Added", data: { queue, job, event, payload } }
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: null,
      }
    }
    return {
      statusCode: 200,
      message:
        raw?.message ||
        'Demande de retrait enregistrée. Vous serez crédité prochainement.',
      data: {
        saved: true,
        transactionId: raw?.data?.payload?.id || null,
      },
    }
  },
}
